import { Observable } from 'rxjs'
import { EditTransactionMode } from '../edit-transaction/edit-transaction.projection'
import {
  TransactionSaveRequest,
  TransactionSaveResponse,
} from '../models/transaction-save.model'

/**
 * Seam between the Create/Edit/Post dialogs and the transaction SAVE endpoint (PVAL-26440),
 * mirroring {@link TransactionActionsService}: abstract here, HTTP in
 * `HttpTransactionSaveService`, bound on the panel component so specs can swap it.
 *
 * The modals inject it directly — they own the request lifecycle (in flight, failed, retried),
 * because a dialog that must stay open and editable on a rejection cannot hand its save to the host.
 */
export abstract class TransactionSaveService {
  /**
   * Save one account's records. Not idempotent: every call creates commands, so a caller sends each
   * body once and retries only a body that failed.
   *
   * @param request one account's body, assembled by `transaction-save.assembly.ts`
   * @param mode    the dialog verb — what the command is attributed to in the commands drawer
   * @returns the created commands. A rejection is delivered as the `HttpErrorResponse` (400 with a
   *          validation array, 409, 403, 5xx, status 0); a 200 whose body is not an array as a
   *          `SaveResponseShapeError`.
   */
  abstract save(
    request: TransactionSaveRequest,
    mode?: EditTransactionMode,
  ): Observable<TransactionSaveResponse>
}
